import React from "react";

interface IWhyOutsourceComponentProps { }

export const WhyOutsourceComponent: React.FC<
    IWhyOutsourceComponentProps
> = (props: IWhyOutsourceComponentProps) => {
    return (
        <section
            id="call-to-action"
            className="call-to-action section dark-background"
        >
            <img
                loading="lazy"
                src="/assets/img/cta-bg.jpg"
                alt="cta-bg-image"
            />

            <div className="container">
                <div
                    className="row"
                    data-aos="zoom-in"
                    data-aos-delay="100"
                >
                    <div className="col-xl-12 text-center text-xl-start">
                        <h3>Why Outsource?</h3>
                        <p data-aos="fade-up" data-aos-delay="300">
                            Accurate & on time employee payroll & complying
                            with statutory laws are crucial to running a
                            successful business. Quick & easy access to
                            accurate data points can help you gain insights
                            into your workforce 1 & help you make
                            adjustments to align them to your business
                            goals.
                        </p>
                        <div className="row">
                            <div
                                className="col-xl-4 text-center text-xl-start p-4"
                                data-aos="fade-up"
                                data-aos-delay="400"
                            >
                                <i
                                    className="bi bi-diagram-3-fill flex-shrink-0"
                                    style={{ fontSize: "6vh" }}
                                />
                                <p>
                                    Managed by Professional Experts Which
                                    help you to concentrate on your on your
                                    core competencies & main business
                                    Operations.
                                </p>
                            </div>
                            <div
                                className="col-xl-4 text-center text-xl-start p-4"
                                data-aos="fade-up"
                                data-aos-delay="500"
                            >
                                <i
                                    className="bi bi-shield-check flex-shrink-0"
                                    style={{ fontSize: "6vh" }}
                                />
                                <p>
                                    Helps you to comply with statutory
                                    obligations with accuracy & in timely
                                    manner.
                                </p>
                            </div>
                            <div
                                className="col-xl-4 text-center text-xl-start p-4"
                                data-aos="fade-up"
                                data-aos-delay="600"
                            >
                                <i
                                    className="bi bi-graph-down flex-shrink-0"
                                    style={{ fontSize: "6vh" }}
                                />
                                <p>
                                    By availing the said service will help
                                    you to achieve cost reduction to almost
                                    1/4th of the existing cost.
                                </p>
                            </div>
                            <div
                                className="col-xl-4 text-center text-xl-start p-4"
                                data-aos="fade-up"
                                data-aos-delay="700"
                            >
                                <i
                                    className="bi bi-check-all flex-shrink-0"
                                    style={{ fontSize: "6vh" }}
                                />
                                <p>
                                    Hassel Free monthly compliance towards
                                    various government acts & notifications.
                                </p>
                            </div>
                            <div
                                className="col-xl-4 text-center text-xl-start p-4"
                                data-aos="fade-up"
                                data-aos-delay="800"
                            >
                                <i
                                    className="bi bi-person-hearts flex-shrink-0"
                                    style={{ fontSize: "6vh" }}
                                />
                                <p>
                                    Need not worry on the attrition of the
                                    employees handling back end Hr team as
                                    the same will be taken care by our
                                    experts.
                                </p>
                            </div>
                            <div
                                className="col-xl-4 text-center text-xl-start p-4"
                                data-aos="fade-up"
                                data-aos-delay="900"
                            >
                                <i
                                    className="bi bi-receipt flex-shrink-0"
                                    style={{ fontSize: "6vh" }}
                                />
                                <p>
                                    Assist you for settlement of claims &
                                    refunds in timely & professional manner.
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    )
}